import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import EventCard from './EventCard'
import { DAY_HEADER_HEIGHT } from './TimeColumn'
import { getEventsForDay, computeOverlapLanes, isSameDay } from './utils'

const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

export default function DayColumn({ day, events, hourStart, hourEnd }) {
  const dayEvents = getEventsForDay(events, day)
  const laneMap = computeOverlapLanes(dayEvents)
  const totalHours = hourEnd - hourStart
  const isToday = isSameDay(day, new Date())

  return (
    <Box sx={{ flex: 1, minWidth: 0 }}>
      {/* Day header */}
      <Box
        sx={{
          textAlign: 'center',
          height: DAY_HEADER_HEIGHT,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: isToday ? 'primary.main' : 'transparent',
          borderRadius: isToday ? 1 : 0,
        }}
      >
        <Typography
          variant="caption"
          sx={{ fontWeight: 600, color: isToday ? '#fff' : 'text.primary' }}
        >
          {DAY_NAMES[day.getDay()]}
        </Typography>
        <Typography
          variant="caption"
          sx={{ display: 'block', color: isToday ? '#fff' : 'text.secondary', fontSize: '0.7rem' }}
        >
          {day.getDate()}
        </Typography>
      </Box>

      {/* Events area */}
      <Box
        sx={{
          position: 'relative',
          height: `${totalHours * 60}px`,
          borderRight: 1,
          borderColor: 'divider',
        }}
      >
        {/* Hour grid lines */}
        {Array.from({ length: totalHours }, (_, i) => (
          <Box
            key={i}
            sx={{
              position: 'absolute',
              top: `${i * 60}px`,
              left: 0,
              right: 0,
              borderBottom: 1,
              borderColor: 'divider',
              opacity: 0.5,
            }}
          />
        ))}

        {/* Events */}
        {dayEvents.map(event => {
          const laneInfo = laneMap.get(event.id) || { lane: 0, totalLanes: 1 }
          return (
            <EventCard
              key={event.id}
              event={event}
              hourStart={hourStart}
              lane={laneInfo.lane}
              totalLanes={laneInfo.totalLanes}
            />
          )
        })}
      </Box>
    </Box>
  )
}
